import {
  FlexBox,
  Modal,
  ModalBody,
  ModalHead,
  Spinner,
  Text,
} from '@dixa/lib-shared-habla';
import { useEffect } from 'react';

import { whatsAppTwilioApi } from 'apis/whatsAppTwilio';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { createAppModal } from 'utils/modal';

import styles from './whatsAppConnectModal.module.scss';

export const WhatsAppConnectModal = createAppModal(
  { type: 'settings:whatsAppConnect' },
  ({ isOpen, modal, hide }): JSX.Element => {
    const notify = useNotifications();

    const { waba_id } = modal.arg.whatsAppSignUpData;

    const handleClose = () => {
      hide?.();
    };

    const [registerWaba] = whatsAppTwilioApi.useRegisterWhatsAppWabaMutation();

    useEffect(() => {
      try {
        const registerWabaOnDixa = async () => {
          await registerWaba({ wabaId: waba_id }).unwrap();

          notify(
            {
              title: 'WhatsApp Business Account successfully registered.',
              time: 3000,
            },
            NotificationType.Success,
          );

          handleClose();
        };

        registerWabaOnDixa();
      } catch (error) {
        notify(
          {
            title:
              'An error occurred while registering WhatsApp Business Account.',
          },
          NotificationType.Error,
        );

        handleClose();
      }
    }, []);

    return (
      <Modal isOpen={isOpen} className={styles.modal} onClose={handleClose}>
        <ModalHead title="WhatsApp for Business" />

        <ModalBody>
          <Text.Paragraph subdued withMarginBottom>
            Registering WhatsApp Business Account...
          </Text.Paragraph>
          <FlexBox
            alignItems="center"
            justifyContent="center"
            height="100%"
            width="100%"
          >
            <Spinner />
          </FlexBox>
        </ModalBody>
      </Modal>
    );
  },
);
